import constants from '../constants';
import { fromJS } from 'immutable';
import { createReducer } from '../../../utils';
import { composeResetReducer } from 'redux-reset-store';

const initialState = {
    selectedBranches: [],
    isFetching: false,
    items: {},
    errors: {},
};

export default composeResetReducer(
    createReducer(fromJS(initialState), {
        [constants.SELECTED_BRANCHES]: (state, payload) => state.merge(payload),
    }),
    fromJS(initialState),
    'AUTH_LOGOUTUSER_REQUEST'
);
